import React from 'react';
import PropTypes from 'prop-types';

export default function ListIcon({ color }) {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.25 9C14.25 8.58579 14.5858 8.25 15 8.25H18C18.9662 8.25 19.75 9.03379 19.75 10V16C19.75 17.5192 18.5192 18.75 17 18.75C15.4808 18.75 14.25 17.5192 14.25 16V9ZM15.75 9.75V16C15.75 16.6908 16.3092 17.25 17 17.25C17.6908 17.25 18.25 16.6908 18.25 16V10C18.25 9.86221 18.1378 9.75 18 9.75H15.75Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M4.25 5C4.25 4.58579 4.58579 4.25 5 4.25H11C11.4142 4.25 11.75 4.58579 11.75 5C11.75 5.41421 11.4142 5.75 11 5.75H5C4.58579 5.75 4.25 5.41421 4.25 5Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M4.25 8.87C4.25 8.45579 4.58579 8.12 5 8.12H11C11.4142 8.12 11.75 8.45579 11.75 8.87C11.75 9.28421 11.4142 9.62 11 9.62H5C4.58579 9.62 4.25 9.28421 4.25 8.87Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M4.25 13.06C4.25 12.6458 4.58579 12.31 5 12.31H8C8.41421 12.31 8.75 12.6458 8.75 13.06C8.75 13.4742 8.41421 13.81 8 13.81H5C4.58579 13.81 4.25 13.4742 4.25 13.06Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M0.25 2C0.25 1.03379 1.03379 0.25 2 0.25H14C14.9662 0.25 15.75 1.03379 15.75 2V9C15.75 9.41421 15.4142 9.75 15 9.75C14.5858 9.75 14.25 9.41421 14.25 9V2C14.25 1.86221 14.1378 1.75 14 1.75H2C1.86221 1.75 1.75 1.86221 1.75 2V16C1.75 16.6908 2.30921 17.25 3 17.25H17C17.4142 17.25 17.75 17.5858 17.75 18C17.75 18.4142 17.4142 18.75 17 18.75H3C1.48079 18.75 0.25 17.5192 0.25 16V2Z" fill={color}/>
    </svg>

  )
}

ListIcon.propTypes = {
  color: PropTypes.string
}

ListIcon.defaultProps = {
  color: '#A39EB8'
}
